import BoxProductListPanel from './boxProductListPanel.container'
export default BoxProductListPanel